import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { HHNTheme } from "hhn-commons";

export const MediaThumbContainer = styled(Box)`
  display: block;
  width: 100%;
  height: 100%;
  border: 4px solid ${HHNTheme.surfaceVariant};
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;
